module.exports = __webpack_public_path__ + "img/header.35b7efa0.jpg";